module.exports = __webpack_public_path__ + "media/5.70fbf793.mp3";